module.exports = __webpack_public_path__ + "static/media/stasis.4f616ee5.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/stasis.jpg
 ** module id = 437
 ** module chunks = 0
 **/